// utils/audio/useSpeakingPulse.js
import { useMemo } from "react";

/**
 * Combine mic volume + agentSpeaking to drive one pulse and speaking state.
 * Returns { pulseScale, speaking: 'client' | 'agent' | 'idle' }.
 *
 * - micVolume: 0..1 (from useMicVolume)
 * - agentSpeaking: boolean (from your TTS/audio player or Redux)
 */
export function useSpeakingPulse(micVolume, agentSpeaking) {
    // Base pulse from mic (0.8..1.4)
    const clientPulse = 0.7 + (micVolume || 0) * 0.6;

    return useMemo(() => {
        if (agentSpeaking) {
            // Agent speaking: steady breathing pulse (1.05..1.15) so it’s visible even in silence
            const t = Date.now() / 500; // ~2Hz
            const breath = 1.1 + Math.sin(t) * 0.05;
            return { pulseScale: breath, speaking: "agent" };
        }
        if ((micVolume || 0) > 0.05) {
            return { pulseScale: clientPulse, speaking: "client" };
        }
        return { pulseScale: 1.0, speaking: "idle" };
    }, [agentSpeaking, micVolume, clientPulse]);
}
